import styles from './index.module.scss';

interface PaginationProps<T> {
  onNextPage: () => void;
  onPrevPage: () => void;
  page: number;
  data: T[];
  pageSize?: number;
}

export const Pagination = <T,>({
  onNextPage,
  onPrevPage,
  page,
  data,
  pageSize = 15,
}: PaginationProps<T>) => (
  <div className={styles.pagination}>
    <button
      className={styles.paginationButton}
      onClick={onPrevPage}
      disabled={page === 1}
      aria-label='Previous information page'
    >
      Prev
    </button>
    <span className={styles.paginationInfo}>
      {page * pageSize - (pageSize - 1)}&hellip;
      {data?.length === pageSize ? page * pageSize - 1 : page * pageSize - (pageSize - data.length)}
    </span>
    <button
      className={styles.paginationButton}
      onClick={onNextPage}
      disabled={data?.length < pageSize}
      aria-label='Next information page'
    >
      Next
    </button>
  </div>
);
